import React, { useMemo, useContext } from 'react';
import styled from 'styled-components';

import { Form, Select, Input, Divider, Card, Typography, Switch } from 'antd';
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';

import RulesForm from './RulesForm';
import AssociationsForm from './AssociationsForm';
import { getTranslatedString } from 'helpers/i18n';

const requiredField = {
  required: true,
  message: getTranslatedString('required'),
};

const StyledSectionContainer = styled.div`
  margin-bottom: 32px;
`;

const Configuration = () => (
  <Row gutter={16}>
    <Col xs={24} sm={20} md={20} lg={20} xl={16}>
      <Card>
        <StyledSectionContainer>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>

          <Form.Item name="status" hidden>
            <Input />
          </Form.Item>

          <Spacer mb={1}>
            <Form.Item name="title" label="Title" hasFeedback rules={[requiredField]}>
              <Input />
            </Form.Item>
          </Spacer>
        </StyledSectionContainer>

        <Divider />

        <StyledSectionContainer>
          <RulesForm />
        </StyledSectionContainer>

        <Divider />

        <AssociationsForm />
      </Card>
    </Col>
  </Row>
);

export default Configuration;
